exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-right[data-v-13294115] { text-align: right !important; padding-right: 5px;\n}\n.overridden[data-v-13294115] {\n    border: 1px solid transparent;\n    border-radius: 5px;\n    border-color: #FF00FF70;\n}\n\n", ""]);

// exports
